import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/CatMaterialAlmacen';

export default {
  async listar(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar`), filtro);
    return response.data;
  },

  async leer(model) {
    const response = await axios.post(getApiUrl(`${BASE}/lectura`), model);
    return response.data;
  },

  async guardar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar`), model);
    return parseMgkResponse(response);
  },

  async borrar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar`), model);
    return response.data;
  }
};
